export default __webpack_public_path__ + "static/media/576.1aa25c87.png";